// extracted by mini-css-extract-plugin
module.exports = {"LoadingPresetCard":"LoadingPresetCard_LoadingPresetCard__3eqKi","loading":"LoadingPresetCard_loading__3Oa_H"};